import {createAction} from "@reduxjs/toolkit";
import type { Tenant } from "../api/cloudServicesManagerApi.ts";

export const setCurrentTenantAction = createAction('setCurrentTenant', function prepare(tenant?: Tenant) {
    return {
        payload: {
            tenant
        },
    }
});
